import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Mumbaitovapicab() {



  const cardData = {
    keyword: " Mumbai to Vapi Cab ",


"headingDescription": "Royal Route Cab offers reliable and comfortable Mumbai to Vapi cab services, ensuring a smooth, safe, and hassle-free journey for families, business travelers, and group passengers. Vapi is an important industrial city in Gujarat located near the Maharashtra border, widely known for its chemical, textile, and manufacturing industries, making it a frequently traveled route from Mumbai. Our professional drivers and well-maintained vehicles ensure a stress-free travel experience throughout the journey. The Mumbai to Vapi route covers approximately 170 to 180 km via NH48 and takes around 3 to 4.5 hours depending on traffic, pickup location, and road conditions. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and Tempo Travellers suitable for all types of travelers. With easy online booking and 24/7 customer support, Royal Route Cab is your trusted partner for Mumbai to Vapi travel.",

"topPlaces": [
  {
    "title": "GIDC Industrial Area",
    "description": "GIDC Industrial Area is the main industrial hub of Vapi and one of the largest chemical and manufacturing zones in India. It showcases the city’s strong industrial identity with thousands of factories and companies operating here. While primarily a business zone, it reflects Vapi’s economic importance and attracts corporate travelers and professionals visiting for work-related purposes."
  },
  {
    "title": "Balitha Garden",
    "description": "Balitha Garden is a peaceful green space in Vapi ideal for morning walks, relaxation, and family outings. It offers clean surroundings, walking paths, and seating areas, making it a refreshing break from the industrial environment of the city."
  },
  {
    "title": "Daman Ganga River Front",
    "description": "Daman Ganga River Front is a scenic stretch along the river flowing near Vapi, offering calm waters, evening views, and relaxing spots for visitors. It is a popular place for locals to unwind and enjoy peaceful sunset moments."
  },
  {
    "title": "Silvassa (Nearby Attraction)",
    "description": "Silvassa, located close to Vapi, is known for its greenery, resorts, and tribal culture. It is a popular weekend getaway featuring gardens, lakes, and eco-tourism spots, making it an ideal extension of a Vapi trip."
  },
  {
    "title": "Vanganga Lake Garden",
    "description": "Vanganga Lake Garden is a beautifully designed garden located in nearby Dadra and Nagar Haveli. It features landscaped lawns, boating facilities, flower beds, and walking tracks, making it a top leisure destination near Vapi."
  },
  {
    "title": "Hirwa Van Garden",
    "description": "Hirwa Van Garden is a well-maintained green park near Vapi known for its artificial waterfalls, fountains, and dense greenery. It is a family-friendly attraction perfect for picnics and relaxation."
  },
  {
    "title": "Daman Beaches (Nearby Coastline)",
    "description": "The nearby beaches of Daman, such as Devka and Jampore, are popular weekend destinations from Vapi. They offer coastal views, seafood stalls, and peaceful sunset experiences just a short drive away."
  },
  {
    "title": "Tapovan Tourist Complex (Silvassa Region)",
    "description": "Tapovan Tourist Complex near Silvassa features gardens, recreational areas, and cultural spaces that attract families and tourists looking for a calm and scenic outing near Vapi."
  },
  {
    "title": "Bhimpore Beach",
    "description": "Bhimpore Beach near Daman is a quieter coastal spot known for its calm atmosphere and scenic shoreline. It is ideal for visitors looking to avoid crowded tourist beaches and enjoy peaceful sea views."
  },
  {
    "title": "Satmaliya Deer Park (Silvassa)",
    "description": "Satmaliya Deer Park is a small wildlife attraction near Silvassa featuring deer, birds, and natural surroundings. It is a great stop for families and nature lovers traveling from Vapi towards nearby tourist regions."
  }
],






services: [
  {
    name: "Mumbai to Vapi Cab",
    description: "Mumbai to Vapi cab service offers a smooth and comfortable journey to one of Gujarat’s key industrial cities. The route via NH48 ensures fast highway connectivity with minimal travel time. Ideal for business travelers, corporate visits, and family trips, this service ensures safe and timely travel. Professional drivers and well-maintained vehicles enhance comfort. Multiple vehicle options are available. It guarantees a reliable and hassle-free journey."
  },
  {
    name: "Mumbai to Vapi Taxi",
    description: "Mumbai to Vapi taxi provides convenient and private transportation with door-to-door pickup and drop. This service is perfect for travelers seeking a comfortable ride for business or personal trips. Vehicles are clean and driven by experienced chauffeurs. Flexible travel timings add convenience. It ensures a smooth and stress-free journey."
  },
  {
    name: "Mumbai to Vapi Cab Service",
    description: "Mumbai to Vapi cab service is designed for efficient intercity travel with a focus on safety and comfort. The highway route ensures a quick and smooth journey. This service is ideal for corporate travel, factory visits, and family travel. Vehicles are maintained for long-distance performance. It ensures a dependable journey."
  },
  {
    name: "Mumbai to Vapi Taxi Service",
    description: "Mumbai to Vapi taxi service offers reliable transportation for business professionals and families. Clean vehicles and trained drivers ensure a comfortable ride. Flexible scheduling allows easy travel planning. Door-to-door service adds convenience. It guarantees a hassle-free experience."
  },
  {
    name: "Cab from Mumbai to Vapi",
    description: "Cab from Mumbai to Vapi provides a personalized travel experience with flexible stops along the route. Travelers can enjoy a comfortable and private journey. This service is ideal for families and small groups. Professional drivers ensure safe travel. It offers a relaxed road trip experience."
  },
  {
    name: "Taxi from Mumbai to Vapi",
    description: "Taxi from Mumbai to Vapi offers a convenient and efficient way to travel between the two cities. With experienced drivers and comfortable vehicles, the journey is smooth and enjoyable. Door-to-door pickup adds convenience. Suitable for business and leisure travel. It ensures a reliable journey."
  },
  {
    name: "Mumbai to Vapi Cab Booking",
    description: "Mumbai to Vapi cab booking allows travelers to reserve their ride easily with flexible options. Customers can choose vehicle type, pickup location, and timing. Instant confirmation and transparent pricing ensure a hassle-free process. It simplifies travel planning."
  },
  {
    name: "Mumbai to Vapi Taxi Booking Online",
    description: "Mumbai to Vapi taxi booking online provides a quick and convenient way to plan your journey. Customers can compare vehicle options and pricing easily. Secure payment and instant confirmation enhance convenience. It ensures availability during peak travel times."
  },
  {
    name: "Mumbai to Vapi Cab Price",
    description: "Mumbai to Vapi cab price varies based on vehicle type, travel timing, and trip type. Transparent pricing ensures no hidden charges. Budget-friendly sedan options and premium SUVs are available. It helps travelers plan their trip efficiently. It ensures value for money."
  },
  {
    name: "Mumbai to Vapi Taxi Fare",
    description: "Mumbai to Vapi taxi fare is designed to be affordable and competitive for short-to-medium distance travel. Fare depends on vehicle type and travel plan. Customers receive clear pricing details before booking. Multiple options suit different budgets. It ensures cost-effective travel."
  },
  {
    name: "Mumbai to Vapi One Way Cab",
    description: "Mumbai to Vapi one way cab is a cost-effective option for travelers needing a single-side drop. This service eliminates return charges and offers flexible travel timings. Ideal for business trips and relocations. Comfortable vehicles ensure a smooth ride. It is perfect for budget travel."
  },
  {
    name: "Mumbai to Vapi Round Trip Taxi",
    description: "Mumbai to Vapi round trip taxi is ideal for travelers planning a return journey on the same or next day. This package includes pickup, drop, waiting time, and return travel. Flexible schedules make it convenient. Suitable for corporate visits and family trips. It ensures comfort and efficiency."
  },
  {
    name: "Mumbai to Vapi Innova Cab",
    description: "Mumbai to Vapi Innova cab is perfect for families and corporate groups seeking spacious and comfortable travel. The vehicle offers ample seating and luggage space. Ideal for long-distance and business travel. Professional drivers ensure safety. It provides a premium travel experience."
  },
  {
    name: "Mumbai to Vapi Ertiga Cab",
    description: "Mumbai to Vapi Ertiga cab is suitable for small groups and families looking for an affordable yet spacious ride. This vehicle offers comfortable seating and good mileage. It is ideal for budget-friendly travel. Drivers ensure smooth journeys. It ensures a pleasant experience."
  },
  {
    name: "Mumbai to Vapi Sedan Cab",
    description: "Mumbai to Vapi sedan cab is ideal for couples and small families seeking economical travel. Sedans offer smooth driving and comfort for intercity trips. This option is widely preferred for its affordability. Professional drivers ensure safe travel. It is perfect for a relaxed journey."
  },
  {
    name: "Mumbai to Vapi SUV Taxi",
    description: "Mumbai to Vapi SUV taxi provides extra space and comfort for group travel. SUVs offer better stability and performance on highways. This option is ideal for families and corporate groups. Drivers ensure safe and reliable travel. It delivers a comfortable experience."
  },
  {
    name: "Cheap Mumbai to Vapi Cab",
    description: "Cheap Mumbai to Vapi cab offers budget-friendly travel options without compromising comfort and safety. This service is ideal for cost-conscious travelers. Economical sedan options help reduce travel costs. Transparent pricing ensures no hidden charges. It is perfect for affordable trips."
  },
  {
    name: "Best Mumbai to Vapi Taxi Service",
    description: "Best Mumbai to Vapi taxi service ensures a premium travel experience with top-quality vehicles and professional drivers. This service focuses on punctuality, safety, and customer satisfaction. Multiple vehicle options are available for different needs. Transparent pricing builds trust. It guarantees a reliable and comfortable journey."
  }
],

tableData: [
  ["Mumbai to Vapi Cab", "Mumbai to Vapi Taxi"],
  ["Mumbai to Vapi Cab Service", "Mumbai to Vapi Taxi Service"],
  ["Cab from Mumbai to Vapi", "Taxi from Mumbai to Vapi"],
  ["Mumbai to Vapi Cab Booking", "Mumbai to Vapi Taxi Booking Online"],
  ["Mumbai to Vapi Cab Price", "Mumbai to Vapi Taxi Fare"],
  ["Mumbai to Vapi One Way Cab", "Mumbai to Vapi Round Trip Taxi"],
  ["Mumbai to Vapi Innova Cab", "Mumbai to Vapi Ertiga Cab"],
  ["Mumbai to Vapi Sedan Cab", "Mumbai to Vapi SUV Taxi"],
  ["Cheap Mumbai to Vapi Cab", "Best Mumbai to Vapi Taxi Service"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Mumbai to Vapi Travel",
    WhyChoosedescription: "Royal Route Cabs offers a smooth and comfortable Mumbai to Vapi cab service, ideal for business travel, industrial visits, and family trips."
  },
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Our drivers are highly experienced on Mumbai to Vapi routes, ensuring safe driving, proper navigation, and timely arrival."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear and upfront pricing including tolls, driver allowance, and all charges with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Mumbai to Vapi cab service operates 24/7, allowing flexible travel anytime as per your schedule."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well-maintained, and regularly cleaned to ensure a comfortable travel experience."
  },
  {
    WhyChooseheading: "One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way cab service, round-trip bookings, or same-day return options for Vapi trips."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for individuals and group travel."
  },
  {
    WhyChooseheading: "Trusted Outstation Cab Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by travelers for Mumbai to Vapi cab bookings due to punctual service, professional drivers, and reliable experience."
  }
]

};

const faqData = [
  { question: "Do you provide Mumbai to Vapi cab service?", answer: "Yes, Royal Route Cabs offers reliable cab services from Mumbai to Vapi for both one-way and round trips." },
  { question: "What is the distance between Mumbai and Vapi?", answer: "The distance is approximately 170 to 180 km and takes around 3.5 to 4.5 hours depending on traffic." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai to Vapi cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we offer pickup from home, hotel, and airport anywhere in Mumbai." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended, especially during peak travel times." },
  { question: "Do you provide same-day return trips?", answer: "Yes, we offer same-day return cab services for Mumbai to Vapi trips." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Hitesh Patel",
    feedback: "Traveling from Mumbai to Vapi with Royal Route Cabs was a smooth and comfortable experience. The driver was professional and maintained safe driving throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Snehal Mehta",
    feedback: "The Mumbai to Vapi ride was hassle-free and well-managed. Royal Route Cabs provided a clean vehicle and timely service, making the journey very comfortable.",
    rating: 5
  }
];


















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Vapi Cab",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-to-vapi-cab.jpg", // replace if needed
  "description": "Book Mumbai to Vapi cab with Royal Route Cabs for a safe, comfortable, and affordable journey. Choose from sedan, SUV, Innova, and luxury cars for one-way and round-trip taxi services with 24x7 availability and professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4200", // adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-to-vapi-cab"
  }
};




  return (
    <div>

<Helmet>
  <title>Mumbai to Vapi Cab | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai to Vapi cab at best price with Royal Route Cabs. One-way & round-trip taxi service with sedan, SUV, Innova & luxury cars. Safe, reliable & 24x7 available."
  />

  <meta
    name="keywords"
    content="mumbai to vapi cab, mumbai to vapi taxi, mumbai to vapi cab service, mumbai to vapi taxi service, cab from mumbai to vapi, taxi from mumbai to vapi, mumbai to vapi cab booking, mumbai to vapi taxi booking online, mumbai to vapi cab price, mumbai to vapi taxi fare, mumbai to vapi one way cab, mumbai to vapi round trip taxi, mumbai to vapi innova cab, mumbai to vapi ertiga cab, mumbai to vapi sedan cab, mumbai to vapi suv taxi, cheap mumbai to vapi cab, best mumbai to vapi taxi service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/94.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitovapicab;